import type { ClientPortalUiVariant } from "../../../env.js";

export const V10_CLIENT_LINK_DEV_FIXTURE_PATH = "/__v10-client-link-fixture";
export const V10_CLIENT_INTAKE_DEV_FIXTURE_PATH = "/__v10-client-intake-fixture";

export function isV10ClientLinkDevFixtureRoute(pathname: string): boolean {
  return pathname === V10_CLIENT_LINK_DEV_FIXTURE_PATH;
}

export function isV10ClientIntakeDevFixtureRoute(pathname: string): boolean {
  return pathname === V10_CLIENT_INTAKE_DEV_FIXTURE_PATH;
}

export function canMountV10ClientLinkDevFixture(input: {
  readonly isDev: boolean;
  readonly portalUiVariant: ClientPortalUiVariant;
  readonly pathname: string;
}): boolean {
  return (
    input.isDev && input.portalUiVariant === "v10" && isV10ClientLinkDevFixtureRoute(input.pathname)
  );
}

export function canMountV10ClientIntakeDevFixture(input: {
  readonly isDev: boolean;
  readonly portalUiVariant: ClientPortalUiVariant;
  readonly pathname: string;
}): boolean {
  return (
    input.isDev && input.portalUiVariant === "v10" && isV10ClientIntakeDevFixtureRoute(input.pathname)
  );
}
